module.exports = __webpack_public_path__ + "img/mobile-streak-progressbar-rocket.edb98b66.svg";